let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gfsdl")).then(() => parcelRequire('7tlUM'));